import {NgModule} from '@angular/core';
import {DepartmentTree2Component} from './department-tree-2.component';
import {SharedModule} from '../../_shared/shared.module';
import {Daterangepicker} from 'ng2-daterangepicker';
import {AngularMultiSelectModule} from 'angular2-multiselect-dropdown';
import { ExpandMode, NgxTreeSelectModule } from 'ngx-tree-select';
@NgModule({
  imports: [
    SharedModule,
    Daterangepicker,
    AngularMultiSelectModule,
    NgxTreeSelectModule.forRoot(
        {
          idField: '_id',
          textField: 'name',
          expandMode: ExpandMode.All
        })
  ],
  declarations: [DepartmentTree2Component],
  exports: [DepartmentTree2Component]
})
export class DepartmentTree2Module {
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/department-tree-2/department-tree-2.module.ts